import Arrow from 'public/icons/arrow left.svg?react';
import { FC } from 'react';
import { cvaBackLink } from '~/entities/BackLink/BackLinkStyles';
import { Link, useNavigate } from '@remix-run/react';

interface Props {
  text: string;
  href?: string;
  onClick?: () => void;
  navigation?: boolean;
}

export const BackLink: FC<Props> = ({
  text,
  href,
  onClick,
  navigation = true,
}) => {
  const navigate = useNavigate();
  const goBack = () => {
    navigation && !href && navigate(-1);
    onClick?.();
  };
  return (
    <div className={cvaBackLink()}>
      {href ? (
        <Link to={href} onClick={goBack}>
          <Arrow height={'2.4rem'} width={'2.4rem'} />
        </Link>
      ) : (
        <div onClick={goBack}>
          <Arrow height={'2.4rem'} width={'2.4rem'} />
        </div>
      )}
      <span>{text}</span>
    </div>
  );
};
